import React from 'react';
import { DocumentationFile } from '../../../../graphql/graphql';
import { ECardView } from '../../Enums/ECardView.enum';
import ECardGridItem from '../ECardGrid/ECardGridItem';
import ECardListItem from '../ECardList/ECardListItem';
import { FileToShare } from '../ECard/ECard';
import { ECardType } from '../../Enums/ECardType.enum';

interface Props {
	item: DocumentationFile;
	view: ECardView;
	reloadData: () => void;
	isShareMode: boolean;
	onItemCheck: (file: FileToShare, isChecked: boolean) => void;
	filesToShare: FileToShare[];
	canBeEdited: boolean;
	eCardType: ECardType;
}

const ECardAllFilesItem: React.FC<Props> = ({
	item,
	view,
	reloadData,
	isShareMode,
	onItemCheck,
	filesToShare,
	canBeEdited,
	eCardType,
}) => {
	switch (view) {
		case ECardView.GRID:
			return (
				<ECardGridItem
					item={item}
					reloadData={reloadData}
					isShareMode={isShareMode}
					onCheck={onItemCheck}
					isSelected={filesToShare.some(file => file.id === item.id)}
					canBeEdited={canBeEdited}
				/>
			);
		case ECardView.LIST:
			return (
				<ECardListItem
					item={item}
					reloadData={reloadData}
					isShareMode={isShareMode}
					onCheck={onItemCheck}
					isSelected={filesToShare.some(file => file.id === item.id)}
					canBeEdited={canBeEdited}
					eCardType={eCardType}
				/>
			);
	}
};

export default ECardAllFilesItem;
